import Vue from 'vue';
import VueHead from 'vue-head';
import App from './App.vue';
import vueSmoothScroll from 'vue-smooth-scroll';
import vuetify from './plugins/vuetify';
import Nl2br from 'vue-nl2br';
import VueI18n from 'vue-i18n';
import ReadMore from 'vue-read-more';

Vue.config.productionTip = false


// VueHead利用
Vue.use(VueHead)

// 改行コードを<br>に変換する
Vue.component('nl2br', Nl2br)

// Vueスムーススクロール使用
Vue.use(vueSmoothScroll);

// ReadMore
Vue.use(ReadMore);


// 多言語対応
Vue.use(VueI18n)
import { localization } from '@/lib/lang/index.js'
const i18n = new VueI18n({
  locale: 'ja', // デフォルト言語
  fallbackLocale: 'jp', // 選択中の言語に対する文字列が存在しない場合はこの言語の文字列を使用する
  messages: localization
})

new Vue({
  vuetify,
  i18n: i18n,
  render: h => h(App)
}).$mount('#app')